import Vue from 'vue';
import router from './router';
require('webpack-icons-installer/bootstrap'); 
import axios from 'axios'

//if (!process.env.IS_WEB) Vue.use(require('vue-electron'))
Vue.http = Vue.prototype.$http = axios
Vue.config.productionTip = false

import App from './App';

import Notifications from 'vue-notification'
 
/*
or for SSR:
import Notifications from 'vue-notification/dist/ssr.js'
*/
 
Vue.use(Notifications)


// turns off the 'You are running Vue in development mode.' msg
Vue.config.productionTip = false;

window.Vue = Vue;

import PortalVue from 'portal-vue'
Vue.use(PortalVue)

import VueNumeric from 'vue-numeric'
Vue.use(VueNumeric)


import {ClientTable} from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bootstrap4');


// These are methods we want to add to the plug-in that we can access
let vueTableExtensions = {
    methods: {
        
    },
    mounted: function() {
        console.log('test');
    }
};

let defaultOptions = Vue.options.components['v-client-table'].options;
Vue.options.components['v-client-table'].options = Vue.util.mergeOptions(defaultOptions, vueTableExtensions);



import PrettyCheckbox from 'pretty-checkbox-vue';
Vue.use(PrettyCheckbox);

import VueSVGIcon from 'vue-svgicon'
Vue.use(VueSVGIcon)





import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fad } from '@fortawesome/pro-duotone-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fas, far, fal, fad)

Vue.component('font-awesome-icon', FontAwesomeIcon)

import Sidebar from './components/Sidebar'
Vue.component('sidebar', Sidebar)


import Loading from './components/Loading'
Vue.component('loading', Loading)

import swal from 'sweetalert'

import store from './store'

import DatePicker from 'vue2-datepicker'
Vue.component('date-picker', DatePicker);

import VueMasonry from 'vue-masonry-css'
Vue.use(VueMasonry);


import VModal from 'vue-js-modal'
Vue.use(VModal, { dialog: true, dynamic: true, injectModalsContainer: true })

import Blocker from './components/Blocker'
Vue.component('blocker', Blocker);

import Scaler from './components/Scaler'
Vue.component('scaler', Scaler);


import ProgressBar from 'vue-simple-progress'
Vue.component('progress-bar', ProgressBar);

//initcode

document.addEventListener('keydown', (e)=>{
    if(e.keyCode === 13 && e.target.tagName === 'INPUT'){
        e.target.blur();
    }
})

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

Vue.component('treeselect', Treeselect);


import ECharts from 'vue-echarts'

import 'echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import 'echarts/lib/component/tooltip'

Vue.component('v-chart', ECharts);

import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

document.addEventListener('dragover', event => event.preventDefault())
document.addEventListener('drop', event => event.preventDefault())


import 'vue-croppa/dist/vue-croppa.css'
import Croppa from 'vue-croppa'
Vue.use(Croppa)       

import api from './api'
Vue.use(api);

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  components: {App},
})